module.exports = __webpack_public_path__ + "img/back-4-b3df0674.png";